import { render, staticRenderFns } from "./FMSendRequestDialog.vue?vue&type=template&id=04b81e0d&"
import script from "./FMSendRequestDialog.vue?vue&type=script&lang=js&"
export * from "./FMSendRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports